<template>
  <div class="space-y-2">
    <div class="text-lg font-bold">
      {{ t(useTranslationPath('components.attachmentsList', label)) }}
    </div>
    <div v-for="(attachment, index) in attachments" :key="`attachment${index}`" class="block">
      <EBadge
        :label="attachment.file_name"
        variant="secondary"
        class="cursor-pointer"
        :icon="getFileIcon(attachment)"
        @click="downloadFile(attachment)"
      />
    </div>
  </div>
</template>

<script setup>
import { useDownloadFile } from '@/composables/useDownloadFile.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { getFileIcon } from '@/utils/getFileIcon.js'
import { EBadge } from '@expansivefm/eds'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  label: {
    type: String,
    default: 'attachments',
  },
  attachments: {
    type: Array,
    default: () => [],
  },
})

const { downloadFile } = useDownloadFile()
const { t } = useI18n()
</script>
